module.exports = __webpack_public_path__ + "front/img/p2.76624f09.png";